// "Hace cuánto" for analysis dates, which Drupal sends as YYYY-MM-DD (some
// collections as DD-MM-YYYY or DD/MM/YYYY). Calendar days, local time.
export function parseLegacyDate(value) {
  const text = String(value == null ? '' : value).trim();
  const iso = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(text), local = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/.exec(text);
  const parts = iso ? [iso[1], iso[2], iso[3]] : local ? [local[3], local[2], local[1]] : null;
  if (!parts) return null;
  const date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return date.getMonth() === Number(parts[1]) - 1 && date.getDate() === Number(parts[2]) ? date : null;
}

const unit = (count, one, many) => `${count} ${count === 1 ? one : many}`;

// Elapsed time in the largest unit that keeps it readable: "hoy", "5 días",
// "3 semanas", "7 meses", "2 años". '-' when unknown or in the future.
export function legacyElapsedSince(value, now = new Date()) {
  const date = parseLegacyDate(value);
  if (!date) return '-';
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.round((today - date) / 86400000);
  if (days < 0) return '-';
  if (days === 0) return 'hoy';
  if (days < 14) return unit(days, 'día', 'días');
  if (days < 61) return unit(Math.floor(days / 7), 'semana', 'semanas');
  let months = (today.getFullYear() - date.getFullYear()) * 12 + today.getMonth() - date.getMonth();
  if (today.getDate() < date.getDate()) months--;
  return months < 24 ? unit(months, 'mes', 'meses') : unit(Math.floor(months / 12), 'año', 'años');
}
